import React from "react";
import { useHistory } from "react-router";

import { Wrapper, Box } from "~/src/components/payroll/style";

import {
  SubpageBox,
  SubpageContentWrapper,
  SubpagesWrapper,
  SubpageTitle,
} from "./views/styles";

const subpages = [
  {
    route: "/shiftstream",
    label: "📈 Status",
    isActive: (path: string) => path === "/shiftstream",
  },
  {
    route: "/shiftstream/streams",
    label: "🧮 Streams",
    isActive: (path: string) => path.startsWith("/shiftstream/streams"),
  },
  {
    route: "/shiftstream/emails",
    label: "📩 Emails",
    isActive: (path: string) => path.startsWith("/shiftstream/emails"),
  },
  {
    route: "/shiftstream/fulfils",
    label: "✅ Fulfils",
    isActive: (path: string) => path.startsWith("/shiftstream/fulfils"),
  },
  {
    route: "/shiftstream/audit",
    label: "📋 Audit Log",
    isActive: (path: string) => path.startsWith("/shiftstream/audit"),
  },
];

type ShiftStreamProps = {
  children: React.ReactNode;
};

const ShiftStream = ({ children }: ShiftStreamProps) => {
  const history = useHistory();

  const path = history.location.pathname;

  return (
    <Wrapper>
      <SubpagesWrapper>
        {subpages.map((page) => {
          const isActive = page.isActive(path);

          return (
            <SubpageBox
              isActive={isActive}
              onClick={() => history.push(page.route)}
            >
              <SubpageContentWrapper>
                <SubpageTitle isActive={isActive}>{page.label}</SubpageTitle>
              </SubpageContentWrapper>
            </SubpageBox>
          );
        })}
      </SubpagesWrapper>

      <Box>{children}</Box>
    </Wrapper>
  );
};

export default ShiftStream;
